var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.props.type === 'reaction-detail')?_c('TUIEmojiPluginDetail',{attrs:{"message":_vm.props.message,"emojiConfig":_vm.props.emojiConfig}}):_c('TUIEmojiPluginAction',{attrs:{"message":_vm.props.message,"emojiConfig":_vm.props.emojiConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }